import { useState, useEffect } from 'react';
import { Tabs } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import 'moment/locale/pt-br';

import { Stack, Button } from '@mui/material';

/* hooks */
import useFlashMessage from '../../../hooks/useFlashMessage';
import { useNavigateParams } from '../../../hooks/useNavigateParams';
import * as TabelaAPI from '../../../api/tabela';

import Input from '../../form/Input';

import TextArea from '../../form/TextArea';
import Checkbox from '../../form/Checkbox';
import SelectEmpresa from '../../form/SelectEmpresa';

function Form({ token, dados, setDados, empresaId, empresaIds, handleSubmit, btnText, caminhoVoltar, OptionsEmpresa }) {
    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigateParams();

    function handleChange(e) {
        let valor = e.target.type === 'checkbox' ? e.target.checked : e.target.value;

        setDados({ ...dados, [e.target.name]: valor });
    }

    async function handleOnBlur(e) {
        //verifica duplicidade
        if (e.target.name === 'descricao' && btnText === 'Cadastrar') {
            const duplicidade = await TabelaAPI.duplicidadeDescricao(
                document.getElementById('empresaId')?.value || 1,
                'Situacoes',
                e.target.value
            );

            if (duplicidade?.uuid) {
                setFlashMessage('Registro em duplicidade!', 'warning');
                return navigate(`/Ambiente/CreateOrEdit`, {
                    uuid: duplicidade.uuid,
                });
            }
        }
    }
    function handleOnFocus(e) {}

    const submit = (e) => {
        e.preventDefault();

        handleSubmit(dados);
    };

    return (
        <Tabs>
            {' '}
            <form onSubmit={submit}>
                <h1>Ambientes</h1>
                <div>
                    <SelectEmpresa
                        text="Selecione a Empresa"
                        name="empresaId"
                        options={OptionsEmpresa}
                        handleOnChange={handleChange}
                        handleOnFocus={handleOnFocus}
                        handleOnBlur={handleOnBlur}
                        value={dados.empresaId || ''}
                        required
                        notOptNull={true}
                    />
                    <Input
                        text="Descrição"
                        type="text"
                        name="descricao"
                        placeholder="Situação"
                        title="Digite o nome do situação"
                        handleOnChange={handleChange}
                        handleOnFocus={handleOnFocus}
                        handleOnBlur={handleOnBlur}
                        value={dados.descricao || ''}
                        required={true}
                    />
                </div>
                <div>
                    {' '}
                    <TextArea
                        text="Título"
                        type="text"
                        name="titulo"
                        placeholder="Texto que auxilia o usuário a compreender o campo"
                        title="Digite o título"
                        handleOnChange={handleChange}
                        handleOnFocus={handleOnFocus}
                        handleOnBlur={handleOnBlur}
                        value={dados.titulo || ''}
                        textAlign="left"
                        linhas="4"
                        //colunas="122"
                    />
                </div>
                <div>
                    <Checkbox
                        title="Modulo Financeiro"
                        text="Financeiro"
                        name="financeiro"
                        handleOnChange={handleChange}
                        value={dados.financeiro}
                        checked={!!dados.financeiro}
                    />
                    <Checkbox
                        title="Modulo Indústria"
                        text="Indústria"
                        name="industria"
                        handleOnChange={handleChange}
                        value={dados.industria}
                        checked={!!dados.industria}
                    />
                    <Checkbox
                        title="Modulo Lançamentos Financeiros"
                        text="Lançamento"
                        name="lancamento"
                        handleOnChange={handleChange}
                        value={dados.lancamento}
                        checked={!!dados.lancamento}
                    />
                    <Checkbox
                        title="Modulo Locação"
                        text="Locação"
                        name="locacao"
                        handleOnChange={handleChange}
                        value={dados.locacao}
                        checked={!!dados.locacao}
                    />
                    <Checkbox
                        title="Modulo Logística"
                        text="Logística"
                        name="logistica"
                        handleOnChange={handleChange}
                        value={dados.logistica}
                        checked={!!dados.logistica}
                    />
                    <Checkbox
                        title="Modulo Movimento"
                        text="Movimento"
                        name="movimento"
                        handleOnChange={handleChange}
                        value={dados.movimento}
                        checked={!!dados.movimento}
                    />
                    <Checkbox
                        title="Modulo Bens"
                        text="Inventario"
                        name="inventario"
                        handleOnChange={handleChange}
                        value={dados.inventario}
                        checked={!!dados.inventario}
                    />
                    <Checkbox
                        title="Ativa quando marcado"
                        text="Ativo"
                        name="ativo"
                        handleOnChange={handleChange}
                        value={dados.ativo}
                        checked={!!dados.ativo}
                    />
                </div>
                <div>
                    <Stack direction="row" spacing={1}>
                        <Button variant="contained" color="secondary" onClick={() => navigate(caminhoVoltar)}>
                            Voltar
                        </Button>
                        <Button type="submit" variant="contained" color="success">
                            {btnText}
                        </Button>
                    </Stack>
                </div>
            </form>
        </Tabs>
    );
}
export default Form;
